import { createSlice } from "@reduxjs/toolkit";
import axios from "../app/axios";
import moment from "moment";

export const applicationSlice = createSlice({
  name: "applicationSlice",
  initialState: {
    applicationData: {},
    applicationDataEdit: {},
    applicationTest: {},
    requestData: {},
    interviewSlot: [],
    documents: [],
    paymentResponse: {},
    applicantFee: {},
    applicantStatus: {},
    optionList: {},
    visibleMinorityList: [],
    recruiterList: [],
    admissionCategoryList: [],
    anotherOptionList: [],
    fileList: {},
    inquiry: {},
    prospectiveData: [],
    countryList: [],
    applicationprospectiveData: [],
    contactprospectiveData: {},
    applicationJsonData: [],
    usbProgram: [],
    academicPeriod: [],
    areaOfInterestData: [],
    previousSchoolData: [],
    transcriptData: [],
    couponsData: [],
    preferredContactList: {},
    preferredGenderCode: {},
    applicationDetails: [],
    checkListData: [],
    applicationDocuments: [],
    files: {},
    errorMessage: undefined,
    dataFetchingStatus: false,
    errorStatusCode: undefined,
    notifyEvents: undefined,
    applicationId: undefined,
    couponsExist: null,
    showPaymentPage: false,
    checkPaymentIsDone: false,
  },

  reducers: {
    setapplicationData: (state, action) => {
      state.applicationData = action.payload;
    },
    setCountryList: (state, action) => {
      state.countryList = action.payload;
    },
    setProspectiveData: (state, action) => {
      state.applicationData = action.payload;
    },
    setApplicationId: (state, action) => {
      state.applicationId = action.payload;
    },
    setApplicationProspectiveData: (state, action) => {
      state.applicationprospectiveData = action.payload;
    },
    setAreaOfInterestData: (state, action) => {
      state.areaOfInterestData = action.payload;
    },
    setPreviousSchoolData: (state, action) => {
      state.previousSchoolData = action.payload;
    },
    setContactProspectiveData: (state, action) => {
      state.contactprospectiveData = action.payload;
    },
    setCheckPaymentIsDone: (state, action) => {
      state.checkPaymentIsDone = action.payload;
    },
    setApplicationJsonData: (state, action) => {
      state.applicationJsonData = action.payload;
    },
    setTranscriptData: (state, action) => {
      state.transcriptData = action.payload;
    },
    setShowPaymentPage: (state, action) => {
      state.showPaymentPage = action.payload;
    },
    setApplicationDocuments: (state, action) => {
      state.applicationDocuments = action.payload;
    },
    setCheckListData: (state, action) => {
      state.checkListData = action.payload;
    },
    setApplicationDetail: (state, action) => {
      state.applicationDetails = action.payload;
    },
    setInquiry: (state, action) => {
      state.inquiry = action.payload;
    },
    setAcademicPeriod: (state, action) => {
      state.academicPeriod = action.payload;
    },
    setUSBProgram: (state, action) => {
      state.usbProgram = action.payload;
    },
    setPaymentResponse: (state, action) => {
      state.paymentResponse = action.payload;
    },
    setApplicantFee: (state, action) => {
      state.applicantFee = action.payload;
    },
    setApplicantStatus: (state, action) => {
      state.applicantStatus = action.payload;
    },
    setDataFiles: (state, action) => {
      state.files = action.payload;
    },
    setOptionList: (state, action) => {
      state.optionList = action.payload;
    },
    setAdmissionCategoryList: (state, action) => {
      state.admissionCategoryList = action.payload;
    },
    setVisibleMinorityList: (state, action) => {
      state.visibleMinorityList = action.payload;
    },
    setRecruiterList: (state, action) => {
      state.recruiterList = action.payload;
    },
    setAnotherOptionList: (state, action) => {
      state.anotherOptionList = action.payload;
    },
    setFileTypesList: (state, action) => {
      state.fileList = action.payload;
    },
    setpreferredContactList: (state, action) => {
      state.preferredContactList = action.payload;
    },
    setpreferredGenderCode: (state, action) => {
      state.preferredGenderCode = action.payload;
    },
    setApplicationTestData: (state, action) => {
      state.applicationTest = action.payload;
    },
    setInterviewSlot: (state, action) => {
      state.interviewSlot = action.payload;
    },
    setDocuments: (state, action) => {
      state.documents = action.payload;
    },
    setErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
    setErrorStatusCode: (state, action) => {
      state.errorStatusCode = action.payload;
    },
    setDataFetchingStatus: (state, action) => {
      state.dataFetchingStatus = action.payload;
    },
    removeElementsFromArray: (state, action) => {
      state.applicationData = action.payload;
    },
    removeApplicationTestData: (state, action) => {
      state.applicationTest = action.payload;
    },
    removeInterviewSlot: (state, action) => {
      state.interviewSlot = action.payload;
    },
    removeExistingStatus: (state, action) => {
      state.applicantStatus = action.payload;
    },
    setapplicationDataEditData: (state, action) => {
      state.applicationDataEdit = action.payload;
    },
    setNotifyEvents: (state, action) => {
      state.notifyEvents = action.payload;
    },
    setRequestData: (state, action) => {
      state.requestData = action.payload;
    },
    setCoupons: (state, action) => {
      state.couponsExist = action.payload;
    },
    setCouponsData: (state, action) => {
      state.couponsData = action.payload;
    },
  },
});

export const {
  setapplicationData,
  setCountryList,
  setProspectiveData,
  setApplicationId,
  setUSBProgram,
  setCoupons,
  setCouponsData,
  setApplicationProspectiveData,
  setAreaOfInterestData,
  setPreviousSchoolData,
  setContactProspectiveData,
  setCheckPaymentIsDone,
  setApplicationJsonData,
  setTranscriptData,
  setShowPaymentPage,
  setApplicationDocuments,
  setCheckListData,
  setApplicationDetail,
  setApplicationTestData,
  setErrorMessage,
  setDataFetchingStatus,
  removeElementsFromArray,
  setapplicationDataEditData,
  setErrorStatusCode,
  removeApplicationTestData,
  setInterviewSlot,
  setDocuments,
  removeInterviewSlot,
  setPaymentResponse,
  setApplicantFee,
  setNotifyEvents,
  setApplicantStatus,
  setDataFiles,
  setInquiry,
  setAcademicPeriod,
  removeExistingStatus,
  setRequestData,
  setOptionList,
  setAdmissionCategoryList,
  setVisibleMinorityList,
  setRecruiterList,
  setAnotherOptionList,
  setFileTypesList,
  setpreferredContactList,
  setpreferredGenderCode,
} = applicationSlice.actions;

export const getApplicationData = (userId) => (dispatch) => {
  dispatch(removeElementsFromArray({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));

  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`application/getContacts/${userId}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setapplicationData(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const getCountryList = () => (dispatch) => {
  dispatch(removeElementsFromArray({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));

  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`inquiry`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setCountryList(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const getApplicantStatus = (userId) => (dispatch) => {
  dispatch(removeExistingStatus({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`application/getApplicantStatus/${userId}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setApplicantStatus(response?.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const deletePreviousSchool = (prevSchoolId) => (dispatch) => {
  dispatch(removeExistingStatus({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .delete(`deletepreviousschool/${prevSchoolId}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const saveDocumentUploadData = (formData) => (dispatch) => {
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .put("/documents/upload", formData, {})
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(response.data.message));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const updateCheckListStatus = (formData) => (dispatch) => {
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .put("/update/checkliststatus", formData, {})
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(response.data.message));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const updateApplicationStatus = (formData) => (dispatch) => {
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .put(`/update/applicationstatus`, formData, {})
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(response.data.message));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getUploadedData = (applicantid, checklistnme) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios
    .get(`files/${applicantid}/${checklistnme}`)
    .then((response) => {
      dispatch(setDataFiles(response.data));
      dispatch(setDataFetchingStatus(false));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const deleteTranscriptRecord = (transId) => (dispatch) => {
  dispatch(removeExistingStatus({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .delete(`deletetranscriptrecord/${transId}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getApplicationProspectiveData = (applicantId) => (dispatch) => {
  dispatch(removeElementsFromArray({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));

  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`application/prospective/${applicantId}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setProspectiveData(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const CreateNewApplicantionRecord = (data) => (dispatch) => {
  dispatch(removeElementsFromArray({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));

  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .post("applicationrecord", data)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setApplicationId(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getProspectiveApplicationData = (applicantId) => (dispatch) => {
  dispatch(removeElementsFromArray({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));

  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`prospective/application/${applicantId}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setApplicationProspectiveData(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getAreaOfInterestData = (applicantId) => (dispatch) => {
  dispatch(removeElementsFromArray({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));

  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`areaOfInterest/${applicantId}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setAreaOfInterestData(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
// Page 5
export const getPreviousSchoolData = (schoolType) => (dispatch) => {
  dispatch(removeElementsFromArray({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));

  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`previousschool/${schoolType}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setPreviousSchoolData(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getApplications = (applicationId, key) => (dispatch) => {
  dispatch(removeElementsFromArray({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));

  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`/application/${applicationId}/${key}`)
    .then((response) => {
      let applicationres = response?.data[0];
      applicationres.usb_applicationsubmitteddate = moment(new Date()).format(
        "YYYY-MM-DD",
      );
      dispatch(setDataFetchingStatus(false));
      dispatch(setApplicationJsonData(applicationres));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getTranscriptData = (applicationId) => (dispatch) => {
  dispatch(removeElementsFromArray({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));

  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`/transcriptData/${applicationId}`)
    .then((response) => {
      let res = response?.data;
      dispatch(setDataFetchingStatus(false));
      dispatch(setTranscriptData(res));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getPaymentPage = (applicationId) => (dispatch) => {
  dispatch(removeElementsFromArray({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));

  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`/displayPaymentPage/${applicationId}`)
    .then((response) => {
      let res = response?.data.length > 0 ? true : false;
      dispatch(setDataFetchingStatus(false));
      dispatch(setShowPaymentPage(res));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const getApplicationDetails = (applicationId) => (dispatch) => {
  dispatch(removeElementsFromArray({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));

  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`/applicationDetail/${applicationId}`)
    .then((response) => {
      let res = response?.data[0];
      dispatch(setDataFetchingStatus(false));
      dispatch(setApplicationDetail(res));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const getCheckListData = (applicationId, applicantId) => (dispatch) => {
  dispatch(removeElementsFromArray({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));

  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`/admissionCheckList/${applicationId}/${applicantId}`)
    .then((response) => {
      let res = response?.data;
      dispatch(setDataFetchingStatus(false));
      dispatch(setCheckListData(res));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getApplicationDocuments = (applicationId) => (dispatch) => {
  dispatch(removeElementsFromArray({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));

  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`/applicationDocuments/${applicationId}`)
    .then((response) => {
      let res = response?.data;
      dispatch(setDataFetchingStatus(false));
      dispatch(setApplicationDocuments(res));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getContactForApplicationForm =
  (applicantId, applicationId) => (dispatch) => {
    dispatch(removeElementsFromArray({}));
    dispatch(setDataFetchingStatus(true));
    dispatch(setErrorMessage(undefined));
    dispatch(setErrorStatusCode(undefined));

    axios.defaults.headers.common["Authorization"] =
      "Bearer " + window.localStorage.getItem("x-auth-token");
    axios
      .get(`/contact/${applicantId}`)
      .then((response) => {
        let res = response?.data[0];
        // if (res.usb_otherphonenumber === null) {
        //   res.usb_otherphonenumber = "+254-";
        //  }
        res.amountdue = window.localStorage.getItem("applicationfee");
        // res.nameOnCard = null;
        // res.creditcard = null;
        res.paymentdone = false;
        res.ticket = null;
        //   res.usb_otherphone = "+254-";
        //  }
        res.expiration = null;
        res.securitycode = null;
        dispatch(setDataFetchingStatus(false));
        dispatch(setContactProspectiveData(res));
      })
      .catch((error) => {
        dispatch(setDataFetchingStatus(false));
        dispatch(setErrorMessage(error.response.data.error));
        dispatch(setErrorStatusCode(error.response.status));
      });
  };
export const checkPaymentIsDone = (applicationId) => (dispatch) => {
  dispatch(removeExistingStatus({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`checkIsPaymentDone/${applicationId}`)
    .then((response) => {
      const res = response.data.length === 0;
      dispatch(setDataFetchingStatus(false));
      dispatch(setCheckPaymentIsDone(res));
    })
    .catch((error) => {
      // dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getOptionList = (entity, attributename) => (dispatch) => {
  dispatch(removeExistingStatus({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`optionSets/${entity}/${attributename}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setOptionList(response.data));
    })
    .catch((error) => {
      // dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getAdmissionCategoryList =
  (entity, attributename) => (dispatch) => {
    dispatch(removeExistingStatus({}));
    dispatch(setDataFetchingStatus(true));
    dispatch(setErrorMessage(undefined));
    dispatch(setErrorStatusCode(undefined));
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + window.localStorage.getItem("x-auth-token");
    axios
      .get(`optionSets/${entity}/${attributename}`)
      .then((response) => {
        dispatch(setDataFetchingStatus(false));
        dispatch(setAdmissionCategoryList(response.data));
      })
      .catch((error) => {
        // dispatch(setDataFetchingStatus(false));
        dispatch(setErrorMessage(error.response.data.error));
        dispatch(setErrorStatusCode(error.response.status));
      });
  };

export const getRecruiterList = () => (dispatch) => {
  dispatch(removeExistingStatus({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`recruiterList`)
    .then((response) => {
      const blankOption = {
        ses_recruiterid: "",
        ses_recruitername: "Choisir un agent de recrutement",
      };
      const updatedRecruiterList = [blankOption, ...response.data];
      dispatch(setDataFetchingStatus(false));
      dispatch(setRecruiterList(updatedRecruiterList));
    })
    .catch((error) => {
      // dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getAnotherOptionList = (entity, attributename) => (dispatch) => {
  dispatch(removeExistingStatus({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`optionSets/${entity}/${attributename}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setAnotherOptionList(response.data));
    })
    .catch((error) => {
      // dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const getfileTypesList = (entity, attributename) => (dispatch) => {
  dispatch(removeExistingStatus({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`optionSets/${entity}/${attributename}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setFileTypesList(response.data));
    })
    .catch((error) => {
      // dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const getpreferredContactList =
  (entity, attributename) => (dispatch) => {
    dispatch(removeExistingStatus({}));
    dispatch(setDataFetchingStatus(true));
    dispatch(setErrorMessage(undefined));
    dispatch(setErrorStatusCode(undefined));
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + window.localStorage.getItem("x-auth-token");
    axios
      .get(`optionSets/${entity}/${attributename}`)
      .then((response) => {
        dispatch(setDataFetchingStatus(false));
        dispatch(setpreferredContactList(response.data));
      })
      .catch((error) => {
        // dispatch(setDataFetchingStatus(false));
        dispatch(setErrorMessage(error.response.data.error));
        dispatch(setErrorStatusCode(error.response.status));
      });
  };
export const getpreferredGenderCode = (entity, attributename) => (dispatch) => {
  dispatch(removeExistingStatus({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`optionSets/${entity}/${attributename}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setpreferredGenderCode(response.data));
    })
    .catch((error) => {
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getApplicationTestData = (userId) => (dispatch) => {
  dispatch(removeApplicationTestData({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`application/applicationTest/${userId}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setApplicationTestData(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const SaveInquiry = (data) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios
    .post("inquiry", data)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setRequestData(response.data));
      dispatch(setErrorMessage(response.data.message));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const checkCoupon = (data) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios
    .post("checkcoupon", data)
    .then((response) => {
      const couponExists = response?.data?.some(
        (element) => element.ses_code === data.usb_couponcode,
      );
      const exist = response.data.length > 0 && couponExists;
      dispatch(setDataFetchingStatus(false));
      dispatch(setCoupons(exist));
      dispatch(setCouponsData(response?.data));
      dispatch(setErrorMessage(response.data.message));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getInquiryData = () => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios
    .get("inquiry")
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setInquiry(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const getAcademicPeriod = (citizenshipstatus,usb_currentstudent,usb_visastatus) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios
    .get(`academicPeriod/${citizenshipstatus}/${usb_currentstudent}/${usb_visastatus}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setAcademicPeriod(response.data.response));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getUSBProgram = (academicPeriod) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios
    .get(`usbprogram/${academicPeriod}`)
    .then((response) => {
      const citizenshipStatus =
        window.localStorage.getItem("citizenshipstatus");
      const isUSBStudent =
        window.localStorage.getItem("usb_currentstudent") === "true";

      if (citizenshipStatus === "Domestic") {
        // If the applicant is Domestic, always use the Domestic query
        return dispatch(setUSBProgram(response.data.usbProgramDomestic));
      } else if (citizenshipStatus === "International") {
        // If the applicant is International and also a USB Student, use the USB Student query
        if (isUSBStudent) {
          return dispatch(
            setUSBProgram(response.data.usbProgramCurrentStudent),
          );
        } else {
          // Otherwise, use the International query
          return dispatch(setUSBProgram(response.data.usbProgramInternational));
        }
      }

      dispatch(setDataFetchingStatus(false));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const SaveApplicationTestData = (data) => (dispatch) => {
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .post("application/applicationTest/", data)
    .then((response) => {
      dispatch(setErrorMessage(response.data.message));
      dispatch(setDataFetchingStatus(false));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const SaveApplicationTestOnlineData = (data) => (dispatch) => {
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .post("application/applicationTestOnline/", data)
    .then((response) => {
      dispatch(setErrorMessage(response.data.message));
      dispatch(setDataFetchingStatus(false));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const postApplicationData = (data) => (dispatch) => {
  dispatch(removeElementsFromArray({}));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .post("application/setContacts", data)
    .then((response) => {
      dispatch(setErrorMessage(response.data.message));
      dispatch(setErrorStatusCode(response.data.responseCode));
      dispatch(setDataFetchingStatus(false));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const updateContactForApplication =
  (data, contactId, applicationIdValue) => (dispatch) => {
    dispatch(setDataFetchingStatus(true));
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + window.localStorage.getItem("x-auth-token");
    axios
      .put(`updatecontact/${contactId}/${applicationIdValue}`, data)
      .then((response) => {
        dispatch(setDataFetchingStatus(false));
        dispatch(setErrorMessage(response.data.state));
      })
      .catch((error) => {
        dispatch(setDataFetchingStatus(false));
        dispatch(setErrorMessage(error.response.data.error));
        dispatch(setErrorStatusCode(error.response.status));
      });
  };

export const updateOtherInfoContactForApplication =
  (data, contactId, applicationId) => (dispatch) => {
    dispatch(setDataFetchingStatus(true));
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + window.localStorage.getItem("x-auth-token");
    axios
      .put(`updateotherinfocontact/${contactId}/${applicationId}`, data)
      .then((response) => {
        dispatch(setDataFetchingStatus(false));
        dispatch(setErrorMessage(response.data.state));
      })
      .catch((error) => {
        dispatch(setDataFetchingStatus(false));
        dispatch(setErrorMessage(error.response.data.error));
        dispatch(setErrorStatusCode(error.response.status));
      });
  };

export const updateApplicationData = (data, applicationId) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .put(`updateapplicationdata/${applicationId}`, data)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(response.data.state));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const updateHighSchoolInfo = (data, applicationId) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .put(`updatehighschooldata/${applicationId}`, data)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(response.data.state));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const updatePostSchoolInfo = (data, applicationId) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .put(`updatepostschooldata/${applicationId}`, data)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(response.data.state));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const updateTranscriptData = (data, applicationId) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .put(`updatetranscriptdata/${applicationId}`, data)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(response.data.state));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const updateAcknowledgement = (data, applicationId) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .put(`updateacknowledgement/${applicationId}`, data)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(response.data.state));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const updatePaymentInfo = (data, applicationId) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .put(`updatepayemntinfo/${applicationId}`, data)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(response.data.state));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const saveCouponCode = (data, applicationId) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .put(`saveCouponCode/${applicationId}`, data)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(response.data.state));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const clearCouponCode = () => (dispatch) => {
  dispatch(setCoupons(null));
};
export const clearCouponCodeData = () => (dispatch) => {
  dispatch(setCouponsData([]));
};
export const clearApplicationData = () => (dispatch) => {
  dispatch(removeElementsFromArray({}));
};

export const updateApplicationEditData = (data) => (dispatch) => {
  dispatch(setapplicationDataEditData(data));
};
export const clearErrorStatusCode = () => (dispatch) => {
  dispatch(setErrorStatusCode(undefined));
};
export const clearErrorMessage = () => (dispatch) => {
  dispatch(setErrorMessage(undefined));
};
export const clearApplicantStatus = () => (dispatch) => {
  dispatch(removeExistingStatus({}));
};

export const saveFileUploadData = (formData) => (dispatch) => {
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .post("/application/fileUpload/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      dispatch(setErrorMessage(response.data.message));
      dispatch(setDataFetchingStatus(false));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getInterviewSlotAvliable = (userId) => (dispatch) => {
  dispatch(removeInterviewSlot([]));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`application/interviewSlotAvailable/`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setInterviewSlot(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getDocuments = (userId) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`documents`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setDocuments(response.data.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const saveInterviewSlot = (body) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .post(`application/interviewSlotAvailable/`, body)
    .then((response) => {
      dispatch(setErrorMessage(response.data.message));
      dispatch(setDataFetchingStatus(false));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const PaymentRequest = (body) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .post(`students/select-class/payment-request`, body)
    .then((response) => {
      dispatch(setPaymentResponse(response.data));
      dispatch(setErrorMessage(response.data.message));
      dispatch(setDataFetchingStatus(false));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const VapulsPaymentRequest = (body) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .post(`/application/payment-request/vapulus`, body)
    .then((response) => {
      dispatch(setPaymentResponse(response.data));
      dispatch(setErrorMessage(response.data.message));
      dispatch(setDataFetchingStatus(false));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getApplicantFee = (userId) => (dispatch) => {
  // dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .post(`application/getApplicationFeeDetails/`, userId)
    .then((response) => {
      // dispatch(setDataFetchingStatus(false));
      dispatch(setApplicantFee(response.data));
    })
    .catch((error) => {
      // dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const updateApplicantPaymentDetails = (userId) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`application/getApplicationFeeDetails/${userId}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(response.data.message));
    })
    .catch((error) => {
      // dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export default applicationSlice.reducer;
